/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 10:54:45
 */
import { isObject, isString } from "@/utils/is";
import dayjs from "dayjs";
const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export function joinTimestamp(join, restful = false) {
    if (!join) {
        return restful ? "" : {};
    }
    const now = new Date().getTime();
    if (restful) {
        return `?_t=${now}`;
    }
    return { _t: now };
}

export function deepMerge(src = {}, target = {}) {
    let key;
    for (key in target) {
        // update-begin--author:liaozhiyang---date:20240329---for：【QQYUN-7872】online表单label较长优化
        src[key] =
            isObject(src[key]) && isObject(target[key]) ? deepMerge(src[key], target[key]) : (src[key] = target[key]);
        // update-end--author:liaozhiyang---date:20240329---for：【QQYUN-7872】online表单label较长优化
    }
    return src;
}

/**
 * @description: Format request parameter time
 */
export function formatRequestDate(params) {
    if (Object.prototype.toString.call(params) !== "[object Object]") {
        return;
    }

    for (const key in params) {
        // 判断是否是dayjs实例
        if (dayjs.isDayjs(params[key])) {
            params[key] = params[key].format(DATE_TIME_FORMAT);
        }
        if (isString(key)) {
            const value = params[key];
            if (value) {
                try {
                    params[key] = isString(value) ? value.trim() : value;
                } catch (error) {
                    throw new Error(error);
                }
            }
        }
        if (isObject(params[key])) {
            formatRequestDate(params[key]);
        }
    }
}

/**
     * Add the object as a parameter to the URL
     * @param baseUrl url
     * @param obj
     * @returns {string}
     * eg:
     *  let obj = {a: '3', b: '4'}
     *  setObjToUrlParams('www.baidu.com', obj)
     *  ==>www.baidu.com?a=3&b=4
     */
export function setObjToUrlParams(baseUrl, obj= {}){
    let parameters = '';
    for (const key in obj) {
    parameters += key + '=' + encodeURIComponent(obj[key]) + '&';
    }
    parameters = parameters.replace(/&$/, '');
    return /\?$/.test(baseUrl) ? baseUrl + parameters : baseUrl.replace(/\/?$/, '?') + parameters;
}
